const heroVideo = document.querySelector('.hero-video:not(.tcmd-hero-carousel .hero-video)');
if (heroVideo) {
  heroVideo.muted = true;
  heroVideo.defaultMuted = true;
  heroVideo.autoplay = true;
  heroVideo.loop = true;
  heroVideo.controls = false;
  heroVideo.playsInline = true;
  heroVideo.setAttribute('muted', '');
  heroVideo.setAttribute('autoplay', '');
  heroVideo.setAttribute('loop', '');
  heroVideo.setAttribute('playsinline', '');
  heroVideo.setAttribute('webkit-playsinline', '');
  heroVideo.removeAttribute('controls');
  const playHero = () => heroVideo.play().catch(() => {});
  if (heroVideo.readyState >= 2) playHero();
  else heroVideo.addEventListener('canplay', playHero, { once: true });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && heroVideo.paused) playHero();
  });
  window.addEventListener('pageshow', playHero);
}

const menuButton = document.querySelector('.menu-button');
const navigation = document.querySelector('.primary-nav');
menuButton?.addEventListener('click', () => {
  const open = navigation?.classList.toggle('open') ?? false;
  menuButton.setAttribute('aria-expanded', String(open));
  document.body.classList.toggle('menu-open', open);
});
navigation?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
  navigation.classList.remove('open');
  menuButton?.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('menu-open');
}));

const productCards = [...document.querySelectorAll('.product-card')];
const filterButtons = [...document.querySelectorAll('button.filter')];

filterButtons.forEach((button) => {
  const filter = button.dataset.filter;
  const hasProducts = filter === 'all' || productCards.some((card) => card.dataset.category === filter);

  if (!hasProducts && !button.hasAttribute('data-keep-visible')) {
    button.hidden = true;
  }

  button.addEventListener('click', () => {
    filterButtons.forEach((item) => {
      item.classList.toggle('active', item === button);
      item.setAttribute('aria-pressed', String(item === button));
    });
    productCards.forEach((card) => {
      card.hidden = filter !== 'all' && card.dataset.category !== filter;
    });
    document.querySelectorAll('[data-preview-category]').forEach((preview) => { preview.hidden = filter !== 'all' && preview.dataset.previewCategory !== filter; });
    const collectionLink = document.querySelector('.collection-link');
    if (collectionLink && button.dataset.collectionUrl) {
      collectionLink.href = button.dataset.collectionUrl;
      collectionLink.textContent = `View all ${button.dataset.collectionLabel} →`;
    }
    if (button.closest('.shop-page')) {
      const url = new URL(window.location.href);
      if (filter === 'all') url.searchParams.delete('category');
      else url.searchParams.set('category', filter);
      window.history.replaceState({}, '', url);
    }
  });
});

const activeFilter = filterButtons.find((button) => button.classList.contains('active') && !button.hidden);
const firstAvailableFilter = filterButtons.find((button) => !button.hidden);
const requestedFilter = new URLSearchParams(window.location.search).get('category');
const requestedFilterButton = filterButtons.find((button) => button.dataset.filter === requestedFilter && !button.hidden);
(requestedFilterButton || activeFilter || firstAvailableFilter)?.click();

const shopPage = document.querySelector('.shop-page');
if (shopPage) {
  const cards = [...shopPage.querySelectorAll('.product-card')];
  const links = [...shopPage.querySelectorAll('[data-category-link]')];
  const isFullCatalog = shopPage.dataset.collectionHandle === 'all';
  const categories = [...new Set(cards.map((card) => card.dataset.category))];
  const requestedCategory = new URLSearchParams(window.location.search).get('category');
  const validCategory = links.some((link) => link.dataset.categoryLink === requestedCategory);
  const selectedCategory = isFullCatalog
    ? (validCategory ? requestedCategory : 'all')
    : (shopPage.dataset.collectionHandle === 'flags' ? 'flags' : (categories.length === 1 ? categories[0] : 'all'));

  links.forEach((link) => {
    const active = link.dataset.categoryLink === selectedCategory;
    link.classList.toggle('active', active);
    if (active) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });
  if (isFullCatalog) {
    cards.forEach((card) => {
      card.hidden = selectedCategory !== 'all' && card.dataset.category !== selectedCategory;
    });
  }
}

const privateDialog = document.querySelector('.private-dialog');
document.querySelector('.private-preview-button')?.addEventListener('click', () => privateDialog?.showModal());
document.querySelector('.dialog-close')?.addEventListener('click', () => privateDialog?.close());
privateDialog?.addEventListener('click', (event) => {
  if (event.target === privateDialog) privateDialog.close();
});
